<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="['update', 'create'].includes(formProps.editType)"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >{{ formProps.editType === 'create' ? '新增隐患' : '编辑隐患' }}</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="隐患详情"> </el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="隐患基本信息" name="baseInfo">
            <HiddenInfo :FormData="formData"></HiddenInfo>
          </el-collapse-item>
          <el-collapse-item title="隐患审核" name="verify">
            <HiddenOk :FormData="formData"></HiddenOk>
          </el-collapse-item>
          <el-collapse-item title="隐患整改" name="rectification">
            <HiddenRectificationView :FormData="formData"></HiddenRectificationView>
          </el-collapse-item>
          <el-collapse-item title="隐患整改延期" name="postpone" v-if="showPostpone">
            <HiddenPostponeView :FormData="formData"></HiddenPostponeView>
          </el-collapse-item>
          <el-collapse-item title="验收" name="accpet">
            <el-form
              ref="formData"
              label-width="150px"
              :model="formData"
              :disabled="formProps.editType === 'read'"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="隐患验收人"
                    prop="personChargeHiddenDangerAcceptanceName"
                    :rules="[
                      {
                        required: true,
                        message: '请输入隐患验收人',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="formData.personChargeHiddenDangerAcceptanceName"
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="验收意见"
                    prop="acceptanceOpinions"
                    :rules="[
                      {
                        required: true,
                        message: '请输入验收意见',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="formData.acceptanceOpinions"
                      placeholder="请输入验收意见"
                      maxlength="500"
                      show-word-limit
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                  <el-form-item
                    label="隐患验收闭环时间"
                    prop="acceptanceTime"
                    :rules="[
                      {
                        required: true,
                        message: '请输入隐患验收闭环时间',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-date-picker
                      size="small"
                      v-model="formData.acceptanceTime"
                      :disabled="formProps.editType === 'read'"
                      type="datetime"
                      class="!w-full"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </el-card>
</template>

<script>
import HiddenInfo from '../business/HiddenInfo'
import HiddenOk from '../business/HiddenOk'
import HiddenRectificationView from '../business/HiddenRectificationView'
import HiddenPostponeView from '../business/HiddenPostponeView'

export default {
  name: 'hidden-book-form',
  components: {
    HiddenOk,
    HiddenInfo,
    HiddenRectificationView,
    HiddenPostponeView,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      formData: {},
      collapseActiveName: ['baseInfo', 'verify', 'rectification', 'postpone', 'accpet'],
    }
  },
  computed: {
    showPostpone() {
      return (
        this.formData.hiddenDangerRectificationExtensionApplicantId ||
        this.formData.hiddenDangerRectificationExtensionApplicationTime ||
        this.formData.logoutTime ||
        this.formData.hiddenDangersRectificationDelayReason
      )
    },
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},

  methods: {},
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
